import { Box } from "@mui/material";
import { Link } from "react-router";

interface NameLinkCellProps {
  path: string;
  children: React.ReactNode;
}

export const NameLinkCell = ({
  path,
  children,
}: NameLinkCellProps): React.ReactNode => {
  return (
    <Box
      component={Link}
      to={path}
      sx={{
        color: "inherit",
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": { textDecoration: "underline" },
      }}
    >
      {children}
    </Box>
  );
};
